import { envConfig } from "../../utils/constants";
import { CountryRegionState } from "../../utils/interfaces/locations";
import { client } from "../graphql";
import { GET_COUNTRY_STATES } from "./queries";

class LocationServices {
  async getCountryStates(): Promise<CountryRegionState> {
    const res = await client.query({
      query: GET_COUNTRY_STATES,
      variables: { countryCode: process.env.REACT_APP_DEFAULT_COUNTRY_CODE },
      context: { headers: { store: envConfig.store } },
    });
    return res.data.country;
  }

  setCountryStates = async (
    action: (res: any) => void,
    callback: () => void
  ) => {
    await this.getCountryStates()
      .then((res: any) => {
        if (res) action(res);
        callback();
      })
      .catch((e: Error) => {
        callback();
      });
  };
}

export default new LocationServices();
